module.exports = __webpack_public_path__ + "img/applicationresults_gj.54364865.jpg";